module.exports = __webpack_public_path__ + "img/ie.aee6f3c0.svg";